import { render } from "./WritingStartView.vue?vue&type=template&id=90e2c6e6&scoped=true&lang=true"
import script from "./WritingStartView.vue?vue&type=script&lang=js"
export * from "./WritingStartView.vue?vue&type=script&lang=js"

import "./WritingStartView.vue?vue&type=style&index=0&id=90e2c6e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e2c6e6"]])

export default __exports__